/**
 * Created by Tiger on 21/07/2022.
 */
import React from "react";
import styled from "@emotion/styled";

interface IBackProps {
  title: string;
  onClick: () => void
}

export default function ({title, onClick}: IBackProps) {
  return (
    <Container onClick={onClick}>
      <img style={{width: 10, height: 18}} src={require('../../../assets/login/mobile/back@3x.png')}/>
      <div style={{marginLeft: 15, fontSize: 17}}>{title}</div>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
`

